/* eslint-disable */
import request from './helpers'

export function listDoc () {
    return request ({
        url: '/api/v1/guide/doc/list',
        method: 'get'
    })
}

export function listSchedule () {
    return request ({
        url: '/api/v1/guide/schedule/get',
        method: 'get'
    })
}
